import { render, staticRenderFns } from "./Maridaje.vue?vue&type=template&id=d3b59854&scoped=true"
import script from "./Maridaje.vue?vue&type=script&lang=js"
export * from "./Maridaje.vue?vue&type=script&lang=js"
import style0 from "./Maridaje.vue?vue&type=style&index=0&id=d3b59854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b59854",
  null
  
)

export default component.exports